export default function ErrorDisplay({error}) {
    if(error == null) return null
    return <pre style={{whiteSpace: 'pre-wrap', color: 'darkred', overflow: 'scroll'}}>
        {error}
    </pre>
}